export function useLenis() {
  const { $lenis } = useNuxtApp();
  return $lenis;
}
